import { useBorrowerIsFinanciallyWorseOff } from '../../../../../../../queries/BorrowerFields/LegalityFields';
import { ToggleButtonLabelSize, YesNoToggleButton } from '@apply/components';
import { ButtonGroupTypes } from 'devextreme-react/button-group';
import { ApplicationQuestionReviewItem } from '../../../../../../components/ApplicationQuestionReviewItem';

interface FinanciallyWorseOffThanLastApplicationProps {
    required?: boolean;
    isReview?: boolean;
}

export const FinanciallyWorseOffThanLastApplication: React.FC<FinanciallyWorseOffThanLastApplicationProps> = ({
    required = false,
    isReview = false,
}) => {
    const label = 'Financially worse off, to a material degree, relative to the time of your last loan application with BFI?';
    const [financiallyWorseOff, set_financiallyWorseOff] = useBorrowerIsFinanciallyWorseOff();

    const toggleButtonYesNoClick = (e: ButtonGroupTypes.ItemClickEvent) => {
        switch (e.itemData?.id.toLowerCase()) {
            case 'yes':
                set_financiallyWorseOff(true);
                return;
            case 'no':
                set_financiallyWorseOff(false);
                return;
            default:
                return;
        }
    };

    const parseDisplayValue = (value: boolean | undefined) => {
        if (value) {
            if (value == true || value == 'true') {
                return 'Yes';
            } else if (value == false || value == 'false') {
                return 'No';
            }
        }
        return '';
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={parseDisplayValue(financiallyWorseOff)}
                />
            ) : (
                <YesNoToggleButton
                    id='financiallyWorseOff'
                    value={financiallyWorseOff}
                    onItemClick={toggleButtonYesNoClick}
                    width='230px'
                    height='40px'
                    required={required}
                    requiredMessage='Financially worse off required'
                    label={label}
                    labelSize={ToggleButtonLabelSize.Medium}
                />
            )}
        </>
    );
};
